import { applyMiddleware, combineReducers, legacy_createStore, compose } from "redux";
import { combineEpics, createEpicMiddleware } from "redux-observable";
import { authReducer, AuthState } from "./auth";
import {
  notificationEpic,
  notificationReducer,
  NotificationState,
} from "./notification";
import { examAttemptReducer, ExamAttemptState } from "./exam-attempt";

const rootReducer = combineReducers<GlobalState>({
  auth: authReducer,
  notification: notificationReducer,
  examAttempt: examAttemptReducer,
});

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootEpic = combineEpics(notificationEpic);

const epicMiddleware = createEpicMiddleware();
const store = legacy_createStore(rootReducer, composeEnhancers(applyMiddleware(epicMiddleware)));

epicMiddleware.run(rootEpic);

export interface GlobalState {
  auth: AuthState;
  notification: NotificationState;
  examAttempt: ExamAttemptState;
}

export default store;
